<template>
  <div class="side-wrap">
    <div class="side">
      <Side ref="side" />
    </div>
    <div class="main-wrap">
      <div class="top-header">
        <NavWrap @active="toggleSide" />
        <div class="breadcrumb-wrap">
          <Breadcrumb />
        </div>
      </div>
      <Ctx v-loading.body="showLoading" />
    </div>
  </div>
</template>

<script>
import Side from './side.vue'
import Ctx from '../ctxWrap/index.vue'
import NavWrap from '../navWrap/index.vue'
import Breadcrumb from '../components/Breadcrumb'
import { mapGetters } from 'vuex'
import { Loading } from 'xlian-ui'

export default {
  name: 'SideWrap',
  components: { Side, NavWrap, Ctx, Breadcrumb },
  data() {
    return {
      loadingInstance: null
    }
  },
  computed: {
    ...mapGetters(['showLoading'])
  },
  methods: {
    toggleSide() {
      this.$refs.side.toggleCollapse()
    }
  }
}
</script>

<style lang="less" scoped>
.side-wrap {
  display: flex;
  height: 100vh;
}
.side {
  flex-shrink: 0;
  height: 100%;
  background: #292f4c;
}
.main-wrap {
  flex: 1;
  width: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .top-header {
    flex-shrink: 0;
  }
}
.breadcrumb-wrap {
  // background: #f4f4f5;
  // padding-bottom: 8px;
}
</style>
